import React, { useCallback, useEffect, useState } from "react";
import { GoogleMap, Marker, useJsApiLoader } from "@react-google-maps/api";

interface LocationMapProps {
  lat: number;
  lng: number;
}

const LocationMap: React.FC<LocationMapProps> = ({ lat, lng }) => {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const center = {
    lat,
    lng,
  };
  const [zoom, setZoom] = useState(3);
  const [map, setMap] = useState<google.maps.Map | null>(null);

  const containerStyle = {
    width: "100%",
    height: "400px",
  };

  const { isLoaded } = useJsApiLoader({
    id: "google-map-script",
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_API_KEY!,
  });
  const onLoad = useCallback(
    (map: google.maps.Map) => {
      setMap(map); // Save the map instance
      map.setCenter(center);
    },
    [center]
  );

  const onUnmount = useCallback(() => {
    setMap(null); // Clean up map instance on unmount
  }, []);

  useEffect(() => {
    if (map) {
      map.setZoom(5); // Set zoom level on the map instance
    }
  }, [map, zoom]);

  if (!isLoaded) return <div>Loading...</div>;
  return (
    <div>
      <GoogleMap
        onLoad={onLoad}
        onUnmount={onUnmount}
        mapContainerStyle={containerStyle}
        center={center}
      >
        <Marker position={center} />
      </GoogleMap>
    </div>
  );
};

export default LocationMap;
